export default __webpack_public_path__ + "static/media/svg-12.82f18c11.svg";